import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Container } from "@mui/material";
import { useMemo } from "react";
export const UiModuleError = ({ children }) => useMemo(() => (_jsx(Container, { maxWidth: "md", style: {
        alignItems: "center",
        display: "flex",
        height: "100vh",
        justifyContent: "center",
    }, children: _jsx(Box, { display: "flex", flexDirection: "column", children: _jsx(Box, { alignItems: "center", display: "flex", justifyContent: "center", marginTop: 2, children: children }) }) })), [children]);
//# sourceMappingURL=ui_module_error.js.map